"use client";

import type { ReactElement, ReactNode } from "react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/utils/lib";

type DesktopTooltipProps = {
  children: ReactElement;
  content: ReactNode;
  className?: string;
  side?: "top" | "bottom" | "left" | "right";
};

export const DesktopTooltip = ({
  children,
  content,
  className,
  side = "top",
}: DesktopTooltipProps) => {
  return (
    <>
      <div className="contents md:hidden">{children}</div>
      <div className="hidden md:contents">
        <TooltipProvider delayDuration={50}>
          <Tooltip>
            <TooltipTrigger asChild>{children}</TooltipTrigger>
            <TooltipContent className={cn(className)} side={side}>
              {content}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </>
  );
};
